module.exports = __webpack_public_path__ + "img/phasesMC.885052b2.png";